/** Merchant copy for the Tests resource index. */
export const shopifyIndexCopy = {
    tests: { singular: 'test', plural: 'tests' },
    status: {
        label: 'Status',
        draft: 'Draft',
        preparing: 'Preparing',
        queued: 'Queued',
        running: 'Running',
        complete: 'Complete',
        finishingUp: 'Finishing up',
        failed: 'Error',
        cancelled: 'Cancelled',
        superseded: 'Superseded',
        unpublished: 'Report unavailable',
        unknown: 'Status unavailable',
    },
    historyErrorTitle: "Couldn't load your tests",
    historyErrorBody: 'Try again to load your tests.',
    partialHistoryTitle: 'Some tests are missing',
    partialHistoryBody: 'Search, filters and counts apply only to the tests loaded here. Try again to load the full history.',
    statusErrorTitle: "Couldn't refresh some test statuses",
    statusErrorBody: 'Showing the last known status where available. Try again to check the latest state.',
    statusStale: 'Last known status',
    statusUnavailable: 'Current status unavailable',
    retry: 'Try again',
    ascending: 'Ascending',
    descending: 'Descending',
    filters: 'Filters',
    loading: 'Loading',
    progress: 'Version progress',
    running: 'Running',
    pageLabel: (page, pages) => `Page ${page} of ${pages}`,
};
//# sourceMappingURL=shopify-index.js.map